import { useState, useEffect } from 'react';
import { EVENT_TYPES, DEFAULT_FLAGS } from '../constants';
export const useUserAndFlags = () => {
    const [user, setUser] = useState(window.STATE?.currentUser || { logged_in: false });
    const [featureFlags, setFeatureFlags] = useState(window.STATE?.featureFlags || DEFAULT_FLAGS);
    useEffect(() => {
        const handleCurrentUserUpdated = () => {
            setUser(window.STATE?.currentUser || { logged_in: false });
            setFeatureFlags(window.STATE?.featureFlags || DEFAULT_FLAGS);
        };
        // Listen for the custom event
        window.addEventListener(EVENT_TYPES.CURRENT_USER_AND_FLAGS_UPDATED, handleCurrentUserUpdated);
        // Initial check
        handleCurrentUserUpdated();
        return () => {
            window.removeEventListener(EVENT_TYPES.CURRENT_USER_AND_FLAGS_UPDATED, handleCurrentUserUpdated);
        };
    }, []);
    return { user, featureFlags };
};
